import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { GridContainer, TableTheme } from "./tableStyles";

const ListTable = ({ rows, columns }) => {
  return (
    <GridContainer>
      <DataGrid
        rows={rows}
        rowHeight={50}
        autoHeight
        columns={columns}
        pageSize={15}
        disableSelectionOnClick
        sx={TableTheme}
      />
    </GridContainer>
  );
};

export default ListTable;
